
import { ISearchResult } from '@/interfaces/ISearchResult';
import router from '@/router';
import { ISelectOption } from '@hakosalo/hakolib';
import axios from 'axios';
import { Ref, computed, defineComponent, ref, watch } from 'vue';
import SearchSelect from './SearchSelect.vue';
import ISearchSelectOption from '@/interfaces/ISearchSelectOption';

export default defineComponent({
    name: "GuideSearch",
    setup() {
        let foundGuides = ref([] as ISearchResult[]);
        let selectedGuide = ref(null as null | number);
        let searchOptions = ref([]) as Ref<ISelectOption<number>[]>;
        async function searchFunction(search: string) {
            try {
                let resp = await axios.get("Guide/Search/" + search);
                foundGuides.value = resp.data;
            }
            catch (error) {
                console.log(error);
            }
        }
        function goToGuide(id: number) {
            router.push({ name: "Artikkeli", params: { id: id } });
        }
        watch(selectedGuide, (newGuide) => {
            if (newGuide !== null && typeof newGuide === "number") {
                goToGuide(newGuide);
            }
        });
        const selectOptions = computed((): ISearchSelectOption<number>[] => {
            return foundGuides.value.map(g => {
               const obj = {} as ISearchSelectOption<number>;
               obj.text = g.category + " > " + g.name;
					obj.category = g.category; 
					obj.name = g.name; 
               obj.value = g.id;
					obj.tags = g.tags;
					obj.categoryRoot = g.categoryRoot;					
               return obj;
            });
        });
        return {
            guides: foundGuides,
            goToGuide,
            selectOptions,
            selectedGuide,
            searchFunction,
            searchOptions,
            foundGuides,
        };
    },
    components: { SearchSelect }
})
